import React from 'react'
import { Bar } from 'react-chartjs-2'
import I18n from 'i18n'
import PropTypes from 'prop-types'
import { interpolateColors } from '../../common/Utils'
import Variables from '../../../stylesheets/variables.module.scss'
const { accentColorDark, accentColorLight } = Variables

const PhysiologicalDetailBarView = (props) => {
  const BOTTOM_PADDING = 55
  const colors = interpolateColors(accentColorDark, accentColorLight, props.limits.length + 1)

  const tooltipRangeDisplay = (context) => {
    const { datasetIndex } = context
    const rangeStart = (datasetIndex - 1) < 0 ? 0 : context.chart.data.datasets[datasetIndex - 1].data[0]
    const rangeEnd = context.raw
    return `${I18n.t('general.hr_zone_number', { number: datasetIndex })}: ${rangeStart} - ${rangeEnd}`
  }

  const createBarOptions = (title) => {
    title = I18n.t(`profile.physiological.attributes.${title}`)
    return {
      indexAxis: 'y',
      plugins: {
        title: {
          display: false,
          text: title || 'Zones'
        },
        tooltip: {
          callbacks: {
            title: () => title,
            label: tooltipRangeDisplay
          }
        },
        legend: {
          display: false
        }
      },
      scales: {
        x: {
          min: props.min,
          max: props.max,
          stacked: false
        },
        y: { stacked: true }
      },
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          bottom: BOTTOM_PADDING
        }
      }
    }
  }
  const convertToBarData = (values) => {
    const fullValues = [props.min].concat(values, props.max)
    const result = fullValues.slice(1).map((elem, idx) => {
      return {
        label: I18n.t('general.zone_number', { number: idx + 1 }),
        data: [elem],
        stack: 'Stack 0',
        backgroundColor: colors[idx]// % 2 === 0 ? highlightColor : '#ccc'
      }
    })
    return { labels: [''], datasets: result }
  }

  return (
    <div className='row'>
      <div className='col s12'>
        <div style={{ height: `${100 + BOTTOM_PADDING}px` }}>
          <Bar data={convertToBarData(props.limits)} options={createBarOptions(props.measureType)} />
        </div>
      </div>
    </div>
  )
}

PhysiologicalDetailBarView.propTypes = {
  // The name of the attribute this chart applies to. Used for the plot title
  measureType: PropTypes.string,
  // Array of the inner limits of the attribute zones
  limits: PropTypes.arrayOf(PropTypes.number),
  // The lowes bound for the attribute
  min: PropTypes.number,
  // The highest bound for the attribute
  max: PropTypes.number
}

export default PhysiologicalDetailBarView
